import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import * as api from "../../../redux/api";
import CustomFileInput from "../../CustomFileInput";
import { reactIcons } from "../../../utils/icons";
// import BackButton from "../../BackButton";

const KYC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [documentTypes, setDocumentTypes] = useState({
    certificateOfIncorporation: [],
    taxCertificate: [],
    miningTradingLicense: []
  });
  const [errors, setErrors] = useState({});
  const [isKyc, setIsKyc] = useState();
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [kycData, setKycData] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const getData = async () => {
      try {
        if (!id) return;
        const res = await api.getUserKycList(id, "user");
        console.log("red");
        if (res.status && res.data) {
          const kycDocs = res.data.data[0];
          setKycData(kycDocs);
          setIsKyc(kycDocs?.verificationStatus);
          setIsReadOnly(!!kycDocs);
          if (kycDocs) {
            setDocumentTypes({
              certificateOfIncorporation:
                kycDocs.certificateOfIncorporation?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || [],
              taxCertificate:
                kycDocs.taxCertificate?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || [],
              miningTradingLicense:
                kycDocs.miningTradingLicense?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || []
            });
          }
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    getData();
  }, [id]);

  console.log("Documents: ", documentTypes);
  console.log("KYC Status: ", isKyc);

  const validate = () => {
    const newErrors = {};
    if (!documentTypes.certificateOfIncorporation.length) {
      newErrors.certificateOfIncorporation =
        "Certificate of Incorporation is required.";
    }
    if (!documentTypes.taxCertificate.length) {
      newErrors.taxCertificate = "Tax Certificate is required.";
    }
    if (!documentTypes.miningTradingLicense.length) {
      newErrors.miningTradingLicense = "Mining/Trading License is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (!validate()) return;
    try {
      setIsLoading(true);
      const payload = {
        organizationId: Number(id),
        certificateOfIncorporation:
          documentTypes.certificateOfIncorporation.map((doc) =>
            typeof doc === "string" ? doc : doc.url
          ),
        taxCertificate: documentTypes.taxCertificate.map((doc) =>
          typeof doc === "string" ? doc : doc.url
        ),
        miningTradingLicense: documentTypes.miningTradingLicense.map((doc) =>
          typeof doc === "string" ? doc : doc.url
        )
      };
      const res = await api.kycSubmit(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("KYC documents submitted successfully");
        setIsReadOnly(true);
        // navigate(`/acknowledgment/${id}`);
      } else {
        toast.error(res?.error?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while submitting the form"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerify = async () => {
    if (!kycData) return;
    try {
      await api.verifyOrRejectKyc(kycData.organizationId, {
        status: "Approved"
      });
      toast.success(`${kycData.user.firstname} has been verified.`);
      navigate(-1);
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.message || "Failed to verify user.");
      console.error(error);
    }
  };

  const handleReject = async () => {
    if (!kycData) return;
    try {
      await api.verifyOrRejectKyc(kycData.organizationId, {
        status: "Rejected",
        kycRejectionReasons: rejectReason
      });
      toast.success(`${kycData.user.firstname} has been rejected.`);
      setRejectModalOpen(false);
      setRejectReason("");
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.message || "Failed to reject user.");
      console.error(error);
    }
  };

  return (
    <div>
      <div className=" text-center justify-items-center pb-10">
        <h2 className="text-black text-24 flex justify-center text-center">
          KYC Document
        </h2>
      </div>
      <form
        className="grid grid-cols-2 gap-4 border border-yellow-dark p-5 rounded-[10px]"
        onSubmit={!isReadOnly ? handleSubmit : undefined}
      >
        <div>
          <CustomFileInput
            label="Certificate of Incorporation"
            allowedFormats="PDF"
            name="certificateOfIncorporation"
            defaultValue={documentTypes.certificateOfIncorporation.map(
              (f) => f.url || f
            )}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                certificateOfIncorporation: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.certificateOfIncorporation && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.certificateOfIncorporation}
            </p>
          )}
        </div>

        <div>
          <CustomFileInput
            label="Tax Certificate"
            allowedFormats="PDF"
            name="taxCertificate"
            defaultValue={documentTypes.taxCertificate.map((f) => f.url || f)}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                taxCertificate: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.taxCertificate && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.taxCertificate}
            </p>
          )}
        </div>
        <div>
          <CustomFileInput
            label="Mining/Trading License"
            allowedFormats="PDF"
            name="miningTradingLicense"
            defaultValue={documentTypes.miningTradingLicense.map(
              (f) => f.url || f
            )}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                miningTradingLicense: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.miningTradingLicense && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.miningTradingLicense}
            </p>
          )}
        </div>
        {rejectModalOpen && kycData && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[400px]">
              <h2 className="text-xl font-semibold mb-4">Reject User</h2>
              <p className="mb-2">
                Are you sure you want to reject{" "}
                <strong>{kycData.user.firstname}</strong>?
              </p>
              <label className="block mb-2 font-medium">
                Reason for rejection:
              </label>
              <textarea
                className="w-full border border-gray-300 rounded p-2"
                rows="4"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Write your reason here..."
              ></textarea>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => {
                    setRejectModalOpen(false);
                    setRejectReason("");
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
                  disabled={!rejectReason.trim()}
                  onClick={async () => {
                    await handleReject();
                    setIsKyc("Rejected");
                    setIsReadOnly(true);
                  }}
                >
                  Confirm Reject
                </button>
              </div>
            </div>
          </div>
        )}
        {verifyModalOpen && kycData && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[400px]">
              <h2 className="text-xl font-semibold mb-4">Verify User</h2>
              <p className="mb-2">
                Are you sure you want to verify{" "}
                <strong>{kycData.user.firstname}</strong>?
              </p>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  className="px-4 py-3 border border-primary-100 font-poppins font-medium rounded-lg"
                  onClick={() => setVerifyModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-4 py-3 font-poppins font-medium bg-primary-100 text-white rounded-lg"
                  onClick={async () => {
                    await handleVerify();
                    setIsKyc("Approved");
                    setIsReadOnly(true);
                    setVerifyModalOpen(false);
                  }}
                >
                  Confirm Verify
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="col-span-2 flex justify-between items-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-danger"
          >
            {reactIcons.arrowleft} Back
          </button>
          {isReadOnly && isKyc === "Pending" ? (
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setVerifyModalOpen(true)}
                className="bg-green-600 px-4 py-3 font-poppins font-medium text-white rounded-lg"
              >
                Verify
              </button>
              <button
                type="button"
                onClick={() => setRejectModalOpen(true)}
                className="btn btn-danger font-poppins font-medium px-4 py-3 text-white rounded-lg"
              >
                Reject
              </button>
            </div>
          ) : (
            <>
              {isKyc === "Approved" && (
                <p className="text-green-600 font-medium">Approved</p>
              )}
              {isKyc === "Rejected" && (
                <p className="text-red-600 font-medium">Rejected.</p>
              )}
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default KYC;
